import { render, staticRenderFns } from "./AltaReclamo.vue?vue&type=template&id=3f43af2e"
import script from "./AltaReclamo.vue?vue&type=script&lang=js"
export * from "./AltaReclamo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports